<div class="scroll-to-top" [ngClass]="{'visible': windowScrolled}" (click)="scrollToTop()">
    <i class="p-button-icon pi pi-chevron-up"></i>
</div>

